import * as types from './constants';

// Create Batch Message Template
export const createBatchMessageTemplateRequest = data => (
  { type: types.CREATE_BATCH_MESSAGE_TEMPLATE_REQUEST, payload: data }
);

export const createBatchMessageTemplateDone = data => (
  { type: types.CREATE_BATCH_MESSAGE_TEMPLATE_DONE, payload: data }
);

export const createBatchMessageTemplateFailed = errors => (
  { type: types.CREATE_BATCH_MESSAGE_TEMPLATE_FAILED, payload: errors }
);

export const createBatchMessageTemplateReset = () => (
  { type: types.CREATE_BATCH_MESSAGE_TEMPLATE_RESET }
);